export const PRIVATE_MUSE_TITLE_SUFFIX = " | Private Muse";
export const MAX_PUBLIC_SEO_TITLE_LENGTH = 70;

const KNOWN_TITLE_SUFFIXES = [
  /\s*\|\s*Private Muse$/i,
  /\s*\|\s*Blog Private Muse$/i,
  /\s*\|\s*Contos Eróticos - Private Muse$/i,
  /\s*\|\s*Contos Eroticos - Private Muse$/i,
];

const normalizeWhitespace = (value = "") =>
  String(value || "")
    .replace(/\s+/g, " ")
    .trim();

export const stripPrivateMuseTitleSuffix = (value = "") => {
  let normalized = normalizeWhitespace(value);

  KNOWN_TITLE_SUFFIXES.forEach((pattern) => {
    normalized = normalized.replace(pattern, "").trim();
  });

  return normalized;
};

const truncateTitleBase = (value = "", maxLength = 0) => {
  const normalized = normalizeWhitespace(value);
  if (!normalized || !Number.isFinite(maxLength) || maxLength <= 0) return "";
  if (normalized.length <= maxLength) return normalized;

  const sliceLength = Math.max(1, maxLength - 3);
  const sliced = normalized.slice(0, sliceLength + 1);
  const boundaryIndex = sliced.lastIndexOf(" ");
  const safeSlice =
    boundaryIndex >= Math.floor(sliceLength * 0.6)
      ? sliced.slice(0, boundaryIndex)
      : normalized.slice(0, sliceLength);

  return `${safeSlice.trim()}...`;
};

export const buildPrivateMuseTitle = (
  value = "",
  { fallback = "", maxLength = MAX_PUBLIC_SEO_TITLE_LENGTH } = {}
) => {
  const normalizedValue = stripPrivateMuseTitleSuffix(value);
  const normalizedFallback = stripPrivateMuseTitleSuffix(fallback);
  const baseTitle = normalizedValue || normalizedFallback;

  if (!baseTitle) return "Private Muse";

  const normalizedMaxLength =
    Number.isFinite(maxLength) && maxLength > PRIVATE_MUSE_TITLE_SUFFIX.length + 8
      ? Math.round(maxLength)
      : MAX_PUBLIC_SEO_TITLE_LENGTH;

  const directTitle = `${baseTitle}${PRIVATE_MUSE_TITLE_SUFFIX}`;
  if (directTitle.length <= normalizedMaxLength) return directTitle;

  const withoutTrailingParenthetical = normalizeWhitespace(
    baseTitle.replace(/\s*\([^)]*\)\s*$/u, "")
  );
  if (withoutTrailingParenthetical) {
    const compactTitle = `${withoutTrailingParenthetical}${PRIVATE_MUSE_TITLE_SUFFIX}`;
    if (compactTitle.length <= normalizedMaxLength) return compactTitle;
  }

  const truncatedBase = truncateTitleBase(
    withoutTrailingParenthetical || baseTitle,
    normalizedMaxLength - PRIVATE_MUSE_TITLE_SUFFIX.length
  );

  return `${truncatedBase}${PRIVATE_MUSE_TITLE_SUFFIX}`;
};
